import { Avatar, Box, Divider, Typography } from '@mui/material';
import defaultUserAvatar from '../../assets/default-user-avatar.png';
import profileDetailsPanelSrc from '../../assets/profile/profile-details-panel.png';

/** Figma 11059:1955 — profile card inner radial panel */
const PROFILE_INNER_BG =
  'radial-gradient(ellipse at center, #3d03a1 63.46%, #2f027e 81.73%, #22005c 100%)';

const rowLabelSx = {
  fontFamily: 'Inter, sans-serif',
  fontWeight: 500,
  fontSize: 14,
  lineHeight: '20px',
  letterSpacing: '0.5px',
  color: '#fff',
  opacity: 0.7,
};

const rowValueSx = {
  fontFamily: 'Inter, sans-serif',
  fontWeight: 500,
  fontSize: 14,
  lineHeight: '20px',
  letterSpacing: '0.5px',
  color: '#fff',
  textAlign: 'right',
};

function DetailRow({ label, value }) {
  return (
    <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 2, minHeight: 20 }}>
      <Typography sx={rowLabelSx}>{label}</Typography>
      <Typography sx={rowValueSx}>{value}</Typography>
    </Box>
  );
}

/** Figma 11059:1951 / 11059:1955 / 11059:1961 — profile details card */
export default function ProfileDetailsCard({ profile }) {
  const rows = [
    { label: 'Full Name:', value: profile.fullName },
    { label: 'Mobile Number', value: profile.phone },
    { label: 'Email:', value: profile.email },
    { label: 'Age:', value: profile.age },
  ];

  return (
    <Box sx={{ width: '100%', maxWidth: 400 }}>
      <Box
        sx={{
          position: 'relative',
          width: '100%',
          height: 380,
          borderRadius: '32px',
          overflow: 'hidden',
          background: PROFILE_INNER_BG,
          boxShadow: 'inset 0 12px 10px rgba(43, 0, 118, 0.39), 0 4px 24px rgba(255, 0, 242, 0.2)',
        }}
      >
        <Avatar
          src={profile.avatarSrc || defaultUserAvatar}
          alt={profile.fullName}
          sx={{
            position: 'absolute',
            left: '50%',
            top: '28px',
            transform: 'translateX(-50%)',
            width: 96,
            height: 96,
            border: '1px solid #ffceca',
            bgcolor: '#ffceca',
            '& .MuiAvatar-img': { objectFit: 'cover', objectPosition: 'center top' },
          }}
        />

        <Box
          sx={{
            position: 'absolute',
            left: '50%',
            top: '156px',
            transform: 'translateX(-50%)',
            width: 360,
            height: 200,
            backgroundImage: `url(${profileDetailsPanelSrc})`,
            backgroundSize: '100% 100%',
            backgroundRepeat: 'no-repeat',
            px: '16px',
            py: '16px',
            boxSizing: 'border-box',
          }}
        >
          <Box sx={{ display: 'flex', flexDirection: 'column', gap: '14px', width: 328 }}>
            {rows.flatMap((row, index) => {
              const items = [<DetailRow key={row.label} label={row.label} value={row.value} />];
              if (index < rows.length - 1) {
                items.push(
                  <Divider
                    key={`${row.label}-divider`}
                    sx={{ borderColor: 'rgba(255,255,255,0.12)', borderBottomWidth: '1px' }}
                  />,
                );
              }
              return items;
            })}
          </Box>
        </Box>
      </Box>
    </Box>
  );
}
